import { Form } from "@client/content/controls";
import { getRootContainerProps, getRootContainerPropsDep } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { type FormButtonProps, type FormFieldInfo } from "@client/controls/Form/component";
import { type GenericMap, Status } from "@client/types";
import { EmailInput } from "@common/controls/Inputs/Text";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

export type MapProps = RootContainerProps & {
  apiInfo: ModuleApiInfo;
  status: string;
};

export type ActionProps = {
  enter: (settings: GenericMap<any>) => void;
};

type Props = ActionProps & MapProps;
export default (props: Props) => {
  const i18n = useI18n();

  const fields = React.useMemo((): FormFieldInfo[] => {
    return [{ Component: EmailInput, label: i18n.email, name: "email" }];
  }, []);

  const SubmitButton = React.useMemo(
    () => (fbp: FormButtonProps) =>
      (
        <ModuleButton
          {...getRootContainerProps(props)}
          isDisabled={fbp.isDisabled || props.status === Status.Saving}
          onClick={fbp.ifValidated(props.enter)}
        >
          {i18n.start}
        </ModuleButton>
      ),
    [...getRootContainerPropsDep(props), props.enter, props.status]
  );

  return <Form {...getRootContainerProps(props)} fields={fields} Button={SubmitButton} />;
};
